export default {
  'failed': '@:terms.payment실패',
  'processing': '@:terms.payment중',
  'unavailable': '@:terms.due-date@:terms.time-over',
  'completed': '@:terms.payment완료',
  'pending': '@:terms.payment@:terms.need',
  'invalid': '@:terms.payment불가',
  'none-cert': '@:terms.certificate 미@:terms.register',
  'processing-cert': '@:terms.certificate @:terms.register중',
  'excluded': '@:terms.exception',
}
